import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { InputField } from '@web/utils/src';
import { useFormContext } from '../FormContext';

export const NamesScreen = () => {
  const { t } = useTranslation();
  const { form, inputHandler, register, errors, formDetails, currentStage } =
    useFormContext();

  return (
    <div className="mb-2-0" role="names-screen">
      <p className="font-bd text-body1">
        {t('create_user_modal.create_account')}
      </p>
      <div className="mt-2-0 grid grid-cols-1 gap-2-0">
        {formDetails[currentStage].map((item) => (
          <InputField
            formValues={form}
            item={item}
            register={register}
            key={item.id}
            errors={errors}
            inputHandler={inputHandler}
            t={t}
          />
        ))}
      </div>
      <div className="mt-4-0 mb-2-0 flex">
        <div>
          <input
            type="checkbox"
            className="accent-primary-yellow w-1-5 h-1-5 rounded-14-0 mr-1-2"
            onChange={(e) => inputHandler('userTerms', !!e.target.checked)}
            role="terms-checkbox"
          />
        </div>
        <p className="text-body1">
          <Trans
            i18nKey="create_user_modal.accept_terms"
            components={[
              <Link
                key="accept_terms"
                to="/terms-and-conditions"
                className="font-bd"
              />,
              <strong key="accept_terms" />,
            ]}
          />
        </p>
      </div>
      <div className="my-2-0 flex">
        <div>
          <input
            type="checkbox"
            className="accent-primary-yellow w-1-5 h-1-5 rounded-14-0 mr-1-2"
            onChange={(e) => inputHandler('userMarketing', !!e.target.value)}
          />
        </div>
        <p className="text-body1">
          <Trans i18nKey="create_user_modal.accept_marketing" />
        </p>
      </div>
    </div>
  );
};

export default NamesScreen;
